import React, { useMemo } from 'react';
import useWidgetStream from 'widgets/streaming/useWidgetStream';

import classNames from 'classnames';
import { WidgetTile } from 'widgets/tiles/components/tile/WidgetTile';
import { TileToolbar } from 'widgets/tiles/components/tile/TileToolbar';
import { CorporateActionsCapsuleContent } from 'widgets/corpActions/capsule/components/CorporateActionsCapsuleContent';
import './CorporateActionsCapsule.scss';
import CorporateActionsCapsuleHelp from 'widgets/corpActions/capsule/components/CorporateActionsCapsuleHelp';

import CorporateActionsCapsuleSettings, {
    CorporateActionsCapsuleSettingsText,
} from 'widgets/corpActions/capsule/components/CorporateActionsCapsuleSettings';
import { SymbolFromConfigOrPortfolioLinkedStatus } from 'portfolio/components/SymbolFromConfigOrPortfolioLinkedStatus';
import ConfigSettingsModal from 'widgets/tiles/components/tile/ConfigSettingsModal';
import { useCorporateActionsCapsuleConfigSlice } from 'widgets/corpActions/capsule/store/configslice';
import { useCorporateActionsAlerts } from 'widgets/corpActions/widget/hooks';
import { useCorporateActionsCapsuleData } from 'widgets/corpActions/capsule/components/useCorporateActionsCapsuleData.ts';

export function CorporateActionsCapsule() {
    useWidgetStream();

    const data = useCorporateActionsCapsuleData();
    const { config, dispatchConfigChanged } =
        useCorporateActionsCapsuleConfigSlice();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const warning = useMemo(() => <SymbolWarning />, [config]);

    const flippable = data.length > 0;

    const messages = useCorporateActionsAlerts();

    const cssClasses = classNames(
        'CorporateActionsCapsule',
        flippable && 'flippable'
    );

    return (
        <WidgetTile className={cssClasses}>
            <TileToolbar
                title="Events"
                settingsBody={<CorporateActionsCapsuleSettings />}
                settingsHeader={CorporateActionsCapsuleSettingsText}
                settingsClassName={'CorporateActionsCapsuleSettingsModal'}
                preceedingItems={<CorporateActionsCapsuleHelp />}
                messages={messages}
            />

            <div className="capsule-body">
                <SymbolFromConfigOrPortfolioLinkedStatus warning={warning}>
                    <CorporateActionsCapsuleContent
                        data={data}
                        config={config}
                    />
                </SymbolFromConfigOrPortfolioLinkedStatus>
            </div>
        </WidgetTile>
    );

    function SymbolWarning() {
        return (
            <span>
                Select a symbol or specify one in the&nbsp;
                <ConfigSettingsModal
                    dispatcher={dispatchConfigChanged}
                    headerText={CorporateActionsCapsuleSettingsText}
                    triggerText={'Capsule Settings'}
                    renderSettings={(p) => (
                        <CorporateActionsCapsuleSettings {...p} />
                    )}
                />
                .
            </span>
        );
    }
}
